import { gql } from '@apollo/client'

export default gql`
  fragment dashboardChecklistInfo on DashboardChecklist {
    id
    name
    uniqueCarCount
  }
`
